import React from 'react'

const CheckmarkSVG = ({ isDark = false, size = 16 }) => {
  const color = isDark ? '#0C1A35' : '#ffffff'
  return (
    <svg
      className="left-[1px] absolute pointer-events-none"
      width={size}
      height={size}
      fill={color}
      viewBox="-3.5 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <script />
      <path d="M4.63 15.638a1.03 1.03 0 0 1-.79-.37L.36 11.09a1.03 1.03 0 1 1 1.58-1.316l2.535 3.043L9.958 3.32a1.029 1.029 0 0 1 1.783 1.03L5.52 15.122a1.03 1.03 0 0 1-.803.511l-.088.004z" />
    </svg>
  )
}

export default CheckmarkSVG
